import { Injectable } from '@angular/core';

@Injectable()
export class TimeUtils {

	private readonly DATE_REGEXP = /(\d{4})-(\d{2})-(\d{2})/;
	private readonly DATE_TIME_REGEXP = /(\d{4})-(\d{2})-(\d{2})T(.+?)\./;
	private readonly SHORT_MONTHS: string[] = [ "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic" ];
	private readonly LONG_MONTHS: string[] = [ "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre" ];	


	public getDateAsString( date: Date ): string {
		return date == null? null: date.getDate() + ' ' + this.getMonthAsString( date.getMonth(), false ) + ' ' + date.getFullYear();
	}

	public getDateTimeAsString( date: Date ): string {
		let str = null;
		if( date !== null && date instanceof Date ) {
			str = date.toLocaleString( undefined, { hour12: false } ) + 'hs';
		}
		return str;		
	}

	public getMonthAsString( month: number, abrev: boolean ): string {
		let months: string[] = abrev? this.SHORT_MONTHS: this.LONG_MONTHS;
		return month == null || Number.isNaN( month ) || month < 0 || month >= months.length? '': months[ month ];
	}
	
	public getDateAsShortString( date: Date, sep: string = '-' ) {
		return date == null? null: date.getDate().toString().padStart( 2, '0' ) + sep + ( date.getMonth() + 1 ).toString().padStart( 2, '0' ) + sep + date.getFullYear(); 
	}
}